<style scoped>
.modal-create-task {
  overflow-y: auto !important;
}

.modal-create-task {
  width: 90vw;
  height: 90vh !important;
}



.p-select {
  width: 100%;
}

.p-textarea {
  background: #fff;
  width: 100% !important;
}

.p-editor .p-editor-content.ql-disabled .ql-editor {
  background: var(--p-select-disabled-background)
}

label {
  font-size: var(--p-floatlabel-active-font-size);
  font-weight: var(--p-floatlabel-label-active-font-weight);
}


.p-message-error {
  color: #dc2626;
  font-size: 14px;
}

.p-message-content {
  height: fit-content !important;
}

.col-bottoni {
  display: flex;
  grid-column-gap: 20px;
  justify-content: end;
}

.close {
  text-align: right;
  margin-bottom: 20px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
}

.p-multiselect, .p-inputtext{
  width: 100%;
}

.card-body {
  position: relative;
  padding: 20px;
}
.p-multiselect-label.p-placeholder{
  opacity: 0 !important;
}
</style>

<template>
  <div v-if="show" id="simple-modal-overlay" class="k-overlay" @click="annulla"></div>
  <div v-if="show" id="simple-modal" class="card-img-overlay popup-global-position modal-create-task">
    <div class="card mb-4">
      <div class="card-body">
        <div class="close" @click="annulla()">
          <i class="pi pi-times" style="font-size: 20px"></i>
        </div>
        <h4>{{ titolo }}</h4>
        <CustomForm v-slot="$form" :resolver="resolver" :initialValues="initialValues" @submit="onFormSubmit"
                    class="flex flex-col gap-4 w-full md:w-56" style="margin-top: 30px;">
          <div class="row">
            <div class="col-md-4 col-12">
              <div class="flex flex-col gap-1">
                <FloatLabel variant="on" class="w-full md:w-56">
                  <CustomSelect filter :virtualScrollerOptions="{ itemSize: 38 }" name="categoria" showClear
                                :options="categorie"  optionLabel="title"
                                optionValue="idCategory" :loading="categorie.length <= 0"  />
                  <label for="over_label">Categoria</label>
                </FloatLabel>
                <Message v-if="$form.categoria?.invalid" severity="error" variant="simple" size="small">Selezionare una categoria</Message>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="flex flex-col gap-1">
                <FloatLabel variant="on" class="w-full md:w-56">
                  <MultiSelect  :virtualScrollerOptions="{ itemSize: 38 }" name="pms" showClear :maxSelectedLabels="3" placeholder="PM"
                                :options="pm"  optionLabel="descrizione" optionValue="id_account" >
                  </MultiSelect >
                  <label for="over_label">PM responsabile</label>
                </FloatLabel>
                <Message v-if="$form.pms?.invalid" severity="error" variant="simple" size="small">Selezionare
                  un PM responsabile</Message>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="flex flex-col gap-1">
                <FloatLabel variant="on" class="w-full md:w-56">
                  <MultiSelect :virtualScrollerOptions="{ itemSize: 38 }" filter name="esecutore" showClear :maxSelectedLabels="3"
                                :options="esecutori"  optionLabel="descrizione" optionValue="id_account"  placeholder="Esecutori" >
                  </MultiSelect >
                  <label for="over_label">Esecutori</label>
                </FloatLabel>
                <Message v-if="$form.esecutore?.invalid" severity="error" variant="simple" size="small">Selezionare
                  un esecutore</Message>
              </div>
            </div>
            <div class="col-12 mt-10">
              <div class="flex flex-col gap-1" style="display: flex; flex-direction: column;">
                <FloatLabel variant="on" class="w-full">
                  <InputText name="titolo" rows="5" cols="10"
                  />
                  <label for="over_label">Titolo attività</label>
                </FloatLabel>
                <Message v-if="$form.titolo?.invalid" severity="error" variant="simple" size="small">Inserire un titolo attività
                </Message>
              </div>
            </div>
            <div class="col-12 mt-10">
              <div class="flex flex-col gap-1" style="display: flex; flex-direction: column;">
                <FloatLabel variant="on" class="w-full">
                  <CustomTextArea name="descrizione" rows="5" cols="10"
                                    />
                  <label for="over_label">Descrizione</label>
                </FloatLabel>
                <Message v-if="$form.descrizione?.invalid" severity="error" variant="simple" size="small">Inserire una descrizione
                </Message>
              </div>
            </div>
            <div class="col-md-3 6 mt-10">
              <div class="flex flex-col gap-1">
                <FloatLabel variant="on" class="w-full md:w-56">
                  <DatePicker name="dataEntroIl" fluid dateFormat="dd/mm/yy" />
                  <label for="over_label">Entro il</label>
                  <Message v-if="$form.dataEntroIl?.invalid" severity="error" variant="simple" size="small">Inserire una data
                  </Message>
                </FloatLabel>
              </div>
            </div>

            <div class="col-12 mt-5 col-bottoni">
              <CustomButton v-if="!daProgrammare" type="submit" severity="primary" :label="btnLabel"></CustomButton>
              <CustomButton @click="annulla()" severity="secondary" label="Annulla"></CustomButton>
            </div>
          </div>
        </CustomForm>
      </div>
    </div>
  </div>
</template>
<script>
import ToggleSwitch from 'primevue/toggleswitch';
import CustomButton from 'primevue/button';
import Message from 'primevue/message';
import CustomTextArea from 'primevue/textarea';
import InputNumber from 'primevue/inputnumber';
import CustomSelect from 'primevue/select';
import { Form as CustomForm } from '@primevue/forms';
import FloatLabel from 'primevue/floatlabel';
import * as $ from 'jquery';
import { ref } from 'vue';
import DatePicker from 'primevue/datepicker';
import { useSlots } from 'vue';
import VirtualScroller from 'primevue/virtualscroller';
import moment from "moment/moment";
import MultiSelect from 'primevue/multiselect';
import InputText from 'primevue/inputtext';
export default {
  name: "KModalCreaAttivita",
  components: { CustomForm, CustomSelect, FloatLabel,  Message, CustomTextArea, CustomButton, DatePicker, MultiSelect, InputText },
  data() {
    return {
      titolo:'Crea nuova attività',
      btnLabel: 'Crea attività',
      userId: -1,
      status: '',
      lavori: [],
      attivita: [{
        cache_titolo: '',
        id_ticket: -1
      }],
      modifica: false,
      $form: ref(),
      taskDaDuplicare: null,
      show: false,
      initialValues: ref({
        dataEntroIl: new Date(),
        categoria:-1
      }),
      images:[],
      daProgrammare:false,
      taskDaProgrammare:null,
      readonlyLavori:false,
      categorie:[],
      pm:[],
      esecutori:[],
      idLavoro:0,
    }
  },
  setup() {
    return {
    }
  },
  mounted() {
    this.$form=ref();
  },
  created() {

    $(document).keyup(function (e) {
      if (e.key === "Escape" && this.show) {
        this.annulla();
      }
    }.bind(this));

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'creaAttivita') {
         this.initialValues={}
        if(mutation.payload.idLavoro){
          this.idLavoro=mutation.payload.idLavoro
        }else{
          this.idLavoro=undefined;
        }

        this.show=true;
        this.$store.dispatch("loadCategorieTicket");
        let es=this.$store.getters.getEsecutori();
        this.pm=es;
        this.esecutori=es;
      }
      if(mutation.type==='categorieTicketLoaded'){
        this.categorie=mutation.payload;
        if(this.idLavoro){
          let idCatLavori=-1;
          for(let cat of this.categorie){
            if(cat.title.includes('LAVORI')){
              idCatLavori=cat.idCategory;
              break
            }
          }

          if(idCatLavori!=-1){
            this.initialValues.categoria=105
          }
        }
      }
      if(mutation.type==='attivitaCreata'){
        this.show=false;
      }
    });
  },
  methods: {

    resolver: ({ values }) => {
      const errors = {};
      if (!values.categoria) {
        errors.categoria = [{ message: 'Selezionare una categoria' }];
      }
      if (!values.pms) {
        errors.pms = [{ message: 'Selezionare un PM' }];
      }
      if (!values.esecutore) {
        errors.esecutore = [{ message: 'Selezionare un esecutore' }];
      }
      if (!values.titolo) {
        errors.titolo = [{ message: 'Inserire un titolo' }];
      }
      if (!values.descrizione) {
        errors.descrizione = [{ message: 'Inserire una descrizione' }];
      }
      return {
        errors
      };
    },
    onFormSubmit({ values, states, valid, errors }) {
      if (valid) {
        let nuovaAttivita = {
          idTicketCategoria: states.categoria.value,
          idPm: states.pms.value,
          idEsecutori: states.esecutore.value,
          titoloAttivita: states.titolo.value,
          descrizioneAttivita: states.descrizione.value,
          dataEntroIl: states.dataEntroIl.value,
          idTicketParent:this.idLavoro
        }

        this.$store.dispatch("saveNuovaAttivita",nuovaAttivita)
      }
    },
    annulla() {
      this.show = false;
      this.userId = -1;
      this.status = "";
      this.modifica = false;
      this.daProgrammare=false;
      this.btnLabel = 'Crea Task Sprint';
      $('html').css('overflow', 'auto');
      let tasks = this.$store.getters.getAllTasks();
      this.$store.dispatch("tasksLoaded", tasks);
    },
  }
}
</script>